export default __webpack_public_path__ + "static/media/dieppe11.82b5b9d9.jpg";